module.exports = __webpack_public_path__ + "static/media/supermacs.603761a0.jpg";